<script setup lang="ts">
const decoration3 = `<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4156 16.4997H8.70157V11.7856" stroke="#949496" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.70117 16.4997L12.4724 12.7285C15.076 10.1249 15.076 5.90394 12.4724 3.30037L12.001 2.82896" stroke="#949496" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
</script>

<template>
  <section class="mt-[110px] md:mt-[172px] container mx-auto grid overflow-hidden relative px-4">
    <AnimateOnScroll animation="fade-up" class="order-4 md:order-0">
      <img
        class="w-full md:w-[418px] md:h-[600px] mx-auto object-contain"
        src="/images/primary/landing-content-1.png"
        alt="Rintisan Billing Product"
        loading="lazy"
      >
    </AnimateOnScroll>

    <AnimateOnScroll animation="fade-down" class="order-1 md:order-0 md:absolute md:top-0 md:left-[140px]">
      <img
        class="w-full mx-auto object-cover md:w-[314px] md:h-[364px] md:object-contain"
        src="/images/primary/landing-content-popup-1.png"
        alt="Product Feature 1"
        loading="lazy"
      >
    </AnimateOnScroll>

    <AnimateOnScroll animation="fade-down" :delay="100" class="order-2 md:order-0 md:absolute md:top-[180px] md:right-[170px]">
      <img
        class="w-full mx-auto object-cover md:w-[314px] md:h-[312px] md:object-contain"
        src="/images/primary/landing-content-popup-2.png"
        alt="Product Feature 2"
        loading="lazy"
      >
    </AnimateOnScroll>

    <div class="mt-[30px] mb-[50px] order-3 mx-auto text-center md:absolute md:-bottom-[20px] md:left-[60px] md:mt-0 md:mb-0">
      <AnimateOnScroll animation="zoom-in">
        <h2 class="text-base text-neutral-700">
          Click & Scan di sini
        </h2>
      </AnimateOnScroll>

      <AnimateOnScroll animation="zoom-in" :delay="100">
        <div
          class="flex justify-center mx-auto"
          v-html="decoration3"
        />
      </AnimateOnScroll>

      <AnimateOnScroll animation="fade-up">
        <img
          class="h-[100px] object-contain w-[202px] mx-auto"
          src="/images/primary/landing-content-popup-3.png"
          alt="QR Code"
          loading="lazy"
        >
      </AnimateOnScroll>
    </div>
  </section>
</template>
